import { Container } from '@icecreamsocial/components';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useRouteConfig, useStore } from '../../../utils/hooks';
import { useBusiness } from '../../../utils/hooks/useBusiness';
import { PageMeta } from '../../presentational';
import NoBusinessState from './components/NoBusinessState';
import Campaign from './sub-routes/Campaign';
import CreateCampaign from './sub-routes/Create';
import CampaignsList from './sub-routes/List';

const Campaigns = () => {
	const store = useStore();
	const { path } = useRouteMatch();

	const { business } = useBusiness({ clientId: store.userClientId });
	const { data: userBusiness } = business;

	const accessibleRoutes = [
		{
			component: CampaignsList,
		},
		{
			path: `view`,
			component: () => <Redirect to={`${path}`} />,
			exact: true,
		},
		{
			path: `view/:campaignId`,
			component: Campaign,
			exact: false,
		},
	];

	const routeConfig = useMemo(() => {
		const accessible = [...accessibleRoutes];
		if (store.userRole !== 'affiliate') {
			accessible.push({
				path: `create`,
				component: CreateCampaign,
				exact: false,
			});
		}
		return accessible;
	}, [store.userRole]);

	const { routes } = useRouteConfig(routeConfig);

	if (!userBusiness?.isConfigured) {
		return <>
			<PageMeta
				title={'Campaigns | Ice Cream Social'}
				description={'No business configured'}
			/>
			<Container>
				<NoBusinessState />
			</Container>
		</>
	}

	return (
		<>
			<PageMeta
				title={'Campaigns | Ice Cream Social'}
				description={'Manage your campaigns'}
			/>

			<Switch>
				{routes.map((route, i) => (
					<Route key={i} {...route} />
				))}
				<Redirect to={path} />
			</Switch>
		</>
	);
};

Campaigns.displayName = 'Campaigns.Main';

export default observer(Campaigns);
